function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null);

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M97,9.057h-7.718V3c0-1.656-1.343-3-3-3s-3,1.344-3,3v6.057H71.178V3c0-1.656-1.343-3-3-3 c-1.656,0-3,1.344-3,3v6.057H53.074V3c0-1.656-1.344-3-3-3c-1.657,0-3,1.344-3,3v6.057H34.97V3c0-1.656-1.344-3-3-3 c-1.657,0-3,1.344-3,3v6.057H16.865V3c0-1.656-1.343-3-3-3s-3,1.344-3,3v6.057H3c-1.657,0-3,1.343-3,3v75.105c0,1.656,1.343,3,3,3 h94c1.657,0,3-1.344,3-3V12.057C100,10.399,98.657,9.057,97,9.057 M94,84.162H6V15.057h4.865v5.947c0,1.656,1.343,3,3,3s3-1.344,3-3 v-5.947H28.97v5.947c0,1.656,1.343,3,3,3c1.656,0,3-1.344,3-3v-5.947h12.104v5.947c0,1.656,1.343,3,3,3c1.656,0,3-1.344,3-3v-5.947 h12.104v5.947c0,1.656,1.344,3,3,3c1.657,0,3-1.344,3-3v-5.947h12.104v5.947c0,1.656,1.343,3,3,3s3-1.344,3-3v-5.947H94V84.162z"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M33.406,31.533H17.3c-1.105,0-2,0.896-2,2v16.105c0,1.104,0.895,2,2,2h16.106c1.104,0,2-0.896,2-2V33.533 C35.406,32.429,34.51,31.533,33.406,31.533 M31.406,47.639H19.3V35.533h12.106V47.639z"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "M57.999,31.533H41.893c-1.104,0-2,0.896-2,2v16.105c0,1.104,0.896,2,2,2h16.106c1.104,0,2-0.896,2-2V33.533 C59.999,32.429,59.104,31.533,57.999,31.533 M55.999,47.639H43.893V35.533h12.106V47.639z"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  d: "M33.406,56.127H17.3c-1.105,0-2,0.896-2,2v16.105c0,1.105,0.895,2,2,2h16.106c1.104,0,2-0.895,2-2V58.127 C35.406,57.022,34.51,56.127,33.406,56.127 M31.406,72.232H19.3V60.127h12.106V72.232z"
});

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  d: "M57.999,56.127H41.893c-1.104,0-2,0.896-2,2v16.105c0,1.105,0.896,2,2,2h16.106c1.104,0,2-0.895,2-2V58.127 C59.999,57.022,59.104,56.127,57.999,56.127 M55.999,72.232H43.893V60.127h12.106V72.232z"
});

var _ref8 =
/*#__PURE__*/
React.createElement("path", {
  d: "M82.702,31.533H66.596c-1.105,0-2,0.896-2,2v16.105c0,1.104,0.895,2,2,2h16.106c1.104,0,2-0.896,2-2V33.533 C84.702,32.429,83.806,31.533,82.702,31.533 M80.702,47.639H68.596V35.533h12.106V47.639z"
});

var SvgScadenze = function SvgScadenze(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 101,
    height: 91,
    viewBox: "-0.906 -0.349 101 91",
    enableBackground: "new -0.906 -0.349 101 91",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgScadenze, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/scadenze.de250155.svg";
export { ForwardRef as ReactComponent };